import { useMutation } from '@tanstack/react-query';
import useSlingApi from '@sdk/api/useSlingApi';
import { PostBulkMessagePayload } from '@sdk/messages/types/apiTypes';

import { useConversationQueryCache } from '@web/conversations/hooks/useConversationQueryCache';
import { mapAPIConversations } from '@web/conversations/utils/mappers';

import { useSoundNotification } from './useSoundNotification';

export const usePostBulkMessage = () => {
  const { addConversations } = useConversationQueryCache();
  const { messages } = useSlingApi();
  const { messageSent } = useSoundNotification();

  const mutation = useMutation({
    mutationFn: async (payload: PostBulkMessagePayload) => {
      messageSent();
      const result = await messages.postBulk(payload);
      const mappedConversations = mapAPIConversations(result.data);

      return mappedConversations;
    },
    onSuccess: async (mapped) => {
      await addConversations(mapped);
    },
  });

  return mutation;
};
